// extracted by mini-css-extract-plugin
export default {"pContent":"Pol_pContent__D3FIU","eventVideo":"Pol_eventVideo__jlUml","pTitle":"Pol_pTitle__8KPc9","pHead":"Pol_pHead__UyGff"};